// 测试环境基地址
// const appBaseUrl = "http://api.test.skcoding.com/app";
// 后端本地基地址
// const appBaseUrl = "http://192.168.130.218:8106/app";
// 线上环境基地址
const appBaseUrl = "http://api.skcoding.com/app";

// ----------------------学生端-------------------------
// 测试学生端地址
// const studentBaseUrl = "http://student.test.skcoding.com/";
// 线上学生端地址
const studentBaseUrl = "https://student.skcoding.com/";

// ----------------------教师端-------------------------
// 测试教师端地址
// const teacherBaseUrl = "http://teacher.test.skcoding.com/";
// 线上教师端地址
const teacherBaseUrl = "http://teacher.skcoding.com/";

// ----------------------教务后台-------------------------
// 测试教务后台地址
// const adminBaseUrl = "http://admin.test.skcoding.com/";
// 线上教务后台地址
const adminBaseUrl = "http://admin.skcoding.com/";
export default {
  appBaseUrl,
  studentBaseUrl,
  teacherBaseUrl,
  adminBaseUrl,
};
